import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiMutationHook } from '../../../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../../../common/queryClient/getMutationFn';

import {
  UserFollowedDataSubjectFormDataType,
  UserFollowedDataSubjectValidFormDataType,
} from '../schema/types';
import { UserFollowedDataSubjectUrl } from './UserFollowedDataSubjectUrl';
import { UserFollowedDataSubjectSchema } from '../schema/UserFollowedDataSubjectSchema';

const postUserFollowedDataSubject = (
  userFollowedDataSubject: UserFollowedDataSubjectValidFormDataType,
  headers?: HttpHeaders,
) =>
  apiClient
    .post<UserFollowedDataSubjectFormDataType>(
      expand(UserFollowedDataSubjectUrl.base, {}),
      UserFollowedDataSubjectSchema.parseMutationDto(userFollowedDataSubject),
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

const deleteUserFollowedDataSubject = (id: number) =>
  apiClient
    .delete<void>(expand(UserFollowedDataSubjectUrl.base, { id }))
    .then((response) => response.data);

export const useMutateUserFollowedDataSubjectQuery = createApiMutationHook(
  ['userFollowedDataSubject'],
  getMutationFn(
    postUserFollowedDataSubject,
    undefined,
    deleteUserFollowedDataSubject,
  ),
);
